import { Injectable } from '@angular/core';
import { HttpClient ,HttpParams, HttpHeaders} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Params4Post } from '../models/General/Params4Post';


@Injectable()
/**
 * user service class
 */
export class UserDataService {
    

    constructor(private http: HttpClient) {
    }
    getUserReg(data: Params4Post){
        return this.http.post(`${environment.apiUrl}/api/other/user-reg/get-user`,data,{withCredentials: true});
    }
    logout(){
        return this.http.get(`${environment.apiUrl}/api/logout`);
    }
    getToken(username, password, company){
        const data = {username : username,password: password, grant_type: 'password',company : company}
        function ObjectsToParams(obj) {
            let p = [];
            for (let key in obj) {
                p.push(key + '=' + encodeURIComponent(obj[key]));
            }
            return p.join('&');
        }
        return this.http.post(`${environment.apiUrl}/token`,ObjectsToParams(data));
    }
}
